import { useEffect, useMemo, useRef } from 'react';

import { useSuperHubStore } from '@core/store/SuperHub';

import XImportBlock from '.';

export const useXImportFromStore = () => {
  const [metadata, revalidateSidebar] = useSuperHubStore(s => [s.document.data?.metadata, s.sidebar.revalidate]);

  const isImporting = useMemo(() => {
    return !!metadata && 'x_import' in metadata && metadata.x_import;
  }, [metadata]);

  const wasImporting = useRef(isImporting);

  /* Revalidate sidebar when a doc's x-import state changes
   */
  useEffect(() => {
    if (isImporting !== wasImporting.current) {
      wasImporting.current = isImporting;
      revalidateSidebar();
    }
  }, [isImporting, revalidateSidebar]);

  return isImporting;
};

const RevalidateDocWhileImporting = ({ children }: { children: React.ReactNode }) => {
  const revalidateDoc = useSuperHubStore(s => s.document.revalidate);
  useEffect(() => {
    const interval = setInterval(() => {
      revalidateDoc();
    }, 10000);
    return () => clearInterval(interval);
  }, [revalidateDoc]);
  return <>{children}</>;
};

export const XImportBlockWrap = ({ children, style }: { children: React.ReactNode; style?: React.CSSProperties }) => {
  const isImporting = useXImportFromStore();
  return isImporting ? (
    <RevalidateDocWhileImporting>
      <XImportBlock style={style} />
    </RevalidateDocWhileImporting>
  ) : (
    <>{children}</>
  );
};

export default XImportBlockWrap;
